import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HelperService {startTime!: Date;
    endTime!: Date;
    running: boolean = false;
    elapsed: number = 0;
  
    startWatch(): void {
      if (!this.running) {
        this.startTime = new Date();
        this.running = true;
        this.elapsed = 0;
        console.log('Watch started');
      }
    }
  
    stopWatch(): void {
      if (this.running) {
        this.endTime = new Date();
        this.elapsed = this.endTime.getTime() - this.startTime.getTime(); // Time difference in milliseconds
        this.running = false;
        console.log('Watch stopped');
        console.log('Elapsed time: ' + (this.elapsed / 1000) + ' seconds');
      }
    }

    deconvertBitmask(bitmask: number, enumObject: any): number[] {
      const selectedOptions: number[] = [];
      for (const [key, value] of Object.entries(enumObject)) {
        if (typeof value === "number" && (bitmask & value) !== 0) {
          selectedOptions.push(value);
        }
      }
      return selectedOptions;
    }
}
